import {
  selectDriversHistoryList,
  selectDriversHistoryListStatus,
} from "../../fleet/fleetSlice";
import {
  TextCapitalized,
  Spacer,
  Avatar,
  RemoveRedEyeOutlined,
  ButtonDS,
  SidePanelDS,
} from "@qivia/ui";
import { useMemo, useCallback, useState } from "react";
import { useAppSelector } from "../../../../redux/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { DriverHistoryModal } from "../modals/driverHistoryModal";

export const DriverHistorySection = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [isDriverHistoryModalOpen, setIsDriverHistoryModalOpen] =
    useState(false);
  const allDriversHistoryList = useAppSelector(selectDriversHistoryList);
  const allDriversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );

  const driversHistoryList = useMemo(
    () => allDriversHistoryList.filter((dh) => dh.vehicleUuid === params.id),
    [allDriversHistoryList, params.id],
  );

  const lastDriver = useMemo(() => driversHistoryList[0], [driversHistoryList]);

  const handleClickDriver = useCallback(() => {
    const firstPath = location.pathname.split("/")[1]; // home or departments
    navigate(`/${firstPath}/drivers/${lastDriver?.driverUuid}`);
  }, [lastDriver?.driverUuid, navigate]);

  //TODO WAITING FOR DEPARTMENT ROUTE
  if (allDriversHistoryListStatus === "idle") {
    return;
  }

  return (
    <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
      <SectionTitle>
        <TextCapitalized>
          {t("vehicles.sidepanel.driversHistory")}
        </TextCapitalized>
      </SectionTitle>
      {lastDriver && (
        <>
          <Spacer y={2} />
          <SidePanelDS.ActionBlock>
            <SidePanelDS.SectionedActionStripe
              left={
                <StyledRowCenter>
                  <TextCapitalized>
                    <Avatar
                      size={"S"}
                      color={"orange"}
                      lastName={lastDriver.driverInfo.lastName}
                      firstName={lastDriver.driverInfo.firstName}
                    />
                  </TextCapitalized>
                  <Spacer x={0.5} />
                  {lastDriver.driverInfo.firstName.concat(
                    " ",
                    lastDriver.driverInfo.lastName,
                  )}
                </StyledRowCenter>
              }
              right={
                <StyledLittleIcon>
                  <RemoveRedEyeOutlined
                    key="driver"
                    onClick={handleClickDriver}
                  />
                  <Spacer x={1} />
                </StyledLittleIcon>
              }
            />
          </SidePanelDS.ActionBlock>
          <Spacer y={1} />
          <ButtonDS
            sizeButton="S"
            format="hug"
            buttonType="secondary"
            text={t("vehicles.sidepanel.viewDriversHistoryList")}
            leftIcon={<RemoveRedEyeOutlined />}
            onClick={() => setIsDriverHistoryModalOpen(true)}
          />
          <DriverHistoryModal
            visible={isDriverHistoryModalOpen}
            onClose={() => setIsDriverHistoryModalOpen(false)}
            driversHistoryList={driversHistoryList}
          />
        </>
      )}
    </SidePanelDS.Section>
  );
};

const StyledLittleIcon = styled.div`
  display: flex;
  cursor: pointer;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
